import React, { useState, useEffect } from "react";

const EditarPerfilModal = ({
  onClose,
  data,
  onSave,
  loading,
  countryOptions = [],
}) => {
  const [form, setForm] = useState({});

  useEffect(() => {
    if (data) {
      setForm({ ...data });
    }
  }, [data]);

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleSubmit = () => {
    // ✅ mandamos al padre los datos actualizados
    onSave({
      ...form,
    });
  };

  return (
    <div className="fixed inset-0 bg-black/30 backdrop-blur-sm flex items-center justify-center z-50">
      <div className="bg-white w-[520px] max-h-[90vh] overflow-y-auto rounded-xl p-8 relative shadow-xl">
        <h2 className="text-2xl font-semibold text-gray-900 mb-6">
          Edit Profile
        </h2>

        <button
          onClick={onClose}
          className="absolute right-6 top-6 text-gray-500 hover:text-black"
          disabled={loading}
        >
          ✕
        </button>

        <div className="space-y-6">
          {/* ✅ Editable */}
          <Field
            label="Name"
            value={form.first_name}
            onChange={(v) => handleChange("first_name", v)}
          />

          <Field
            label="Second Name"
            value={form.second_name}
            onChange={(v) => handleChange("second_name", v)}
          />

          <Field
            label="Last Name"
            value={form.last_name}
            onChange={(v) => handleChange("last_name", v)}
          />

          {/* ❌ Solo lectura */}
          <Field label="Email" value={form.email} readOnly />
          <Field label="User Name" value={form.userName} readOnly />
          <SelectField
            label="Country or Region"
            value={form.country}
            onChange={(v) => handleChange("country", v)}
            options={countryOptions}
            disabled={loading}
          />

          {/* ❌ Solo lectura */}
          <Field label="Organization" value={form.organization} readOnly />
        </div>

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="mt-8 w-full bg-black text-white rounded-lg py-3 text-lg hover:bg-gray-800 disabled:opacity-60 disabled:cursor-not-allowed"
        >
          {loading ? "Saving..." : "Save"}
        </button>
      </div>
    </div>
  );
};

export default EditarPerfilModal;

// 🧩 Field con soporte readOnly
const Field = ({ label, value, onChange, readOnly = false }) => (
  <div className="border-b pb-3">
    <label className="text-xs text-gray-500">{label}</label>
    <input
      type="text"
      className={`w-full mt-1 text-lg bg-transparent outline-none ${
        readOnly ? "text-gray-400 cursor-not-allowed" : "text-gray-900"
      }`}
      value={value ?? ""}
      readOnly={readOnly}
      onChange={readOnly ? undefined : (e) => onChange?.(e.target.value)}
    />
  </div>
);

const SelectField = ({
  label,
  value,
  onChange,
  options = [],
  disabled = false,
}) => (
  <div className="border-b pb-3">
    <label className="text-xs text-gray-500">{label}</label>
    <select
      className="w-full mt-1 text-lg bg-transparent outline-none text-gray-900"
      value={value ?? ""}
      onChange={(e) => onChange?.(e.target.value)}
      disabled={disabled}
    >
      <option value="">Select a Country or Region</option>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);
